import { render, staticRenderFns } from "./tab-history.vue?vue&type=template&id=6620add7&scoped=true"
import script from "./tab-history.vue?vue&type=script&lang=js"
export * from "./tab-history.vue?vue&type=script&lang=js"
import style0 from "./tab-history.vue?vue&type=style&index=0&id=6620add7&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6620add7",
  null
  
)

export default component.exports